import script from "./ProjectModalControl.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectModalControl.vue?vue&type=script&setup=true&lang=js"

import "./ProjectModalControl.vue?vue&type=style&index=0&id=d9c6a4be&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9c6a4be"]])

export default __exports__